export default __webpack_public_path__ + "static/jira-hero-img-bc33ec6c797bd5f4ae1282a55e750c25.png";